export interface Article {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  tags: string[];
  author: string;
  publishedAt: string;
  views: number;
  featured: boolean;
  content: string[];
}

export const articles: Article[] = [
  {
    id: 'n1',
    title: '全国多地推进城市更新行动，老旧小区焕发新活力',
    summary:
      '从加装电梯到完善养老托育设施，一批老旧小区在改造中重新找回烟火气，居民生活品质显著提升。',
    cover:
      'https://readdy.ai/api/search-image?query=renovated%20residential%20community%20courtyard%20with%20playground%20and%20green%20trees%2C%20warm%20autumn%20afternoon%20light%2C%20editorial%20urban%20photography&width=1200&height=675&seq=news-01&orientation=landscape',
    category: 'news',
    tags: ['城市更新', '民生', '社区'],
    author: '本刊记者 林清',
    publishedAt: '2026-10-11 09:20',
    views: 18842,
    featured: true,
    content: [
      '近年来，多地把城市更新作为改善民生的重要抓手，从群众最关心、最直接的问题入手，推动老旧小区改造由"改房子"向"改生活"延伸。',
      '在东部某市，一个建成超过二十年的小区经过系统改造后，不仅加装了电梯、翻新了外立面，还利用拆除违建腾出的空间建起了口袋公园和社区食堂，老年人下楼就能吃上热乎饭。',
      '相关负责人介绍，改造过程中坚持"居民点单、政府答卷"，通过议事会收集意见，把停车难、管线老化、缺少活动场地等痛点逐一列入清单，改造完成后再由居民打分验收。',
      '专家表示，城市更新不是简单的"刷墙换瓦"，而是要在有限空间里补齐公共服务短板，让老城区既留住记忆，也装得下现代生活。',
      '下一步，多地将继续探索可持续的运维机制，引入社会力量参与，让改造成果长期惠及居民。',
    ],
  },
  {
    id: 'n2',
    title: '秋季消费市场持续回暖，多个品类迎来销售高峰',
    summary:
      '换季消费叠加假日经济，家电、服饰与餐饮等多个品类销量走高，消费活力进一步释放。',
    cover:
      'https://readdy.ai/api/search-image?query=busy%20modern%20shopping%20street%20with%20autumn%20decoration%20and%20shoppers%2C%20warm%20golden%20hour%20light%2C%20editorial%20retail%20photography&width=1200&height=675&seq=news-02&orientation=landscape',
    category: 'news',
    tags: ['消费', '市场', '经济'],
    author: '本刊记者 周衡',
    publishedAt: '2026-10-10 16:05',
    views: 12930,
    featured: false,
    content: [
      '随着天气转凉，换季需求集中释放，叠加假期出行带动，秋季消费市场呈现稳中向好的态势。',
      '数据显示，家电、服饰、餐饮和家居用品成为表现较为亮眼的品类，其中节能家电与智能化产品的关注度明显上升。',
      '多家商场负责人表示，线下体验与线上引流的结合更加紧密，门店通过场景化陈列和互动活动吸引客流，客单价与复购率同步改善。',
      '业内人士分析，消费结构正从"买商品"向"买体验"转变，能够提供情绪价值和品质保障的品牌更容易获得青睐。',
    ],
  },
  {
    id: 'n3',
    title: '新版城市公共交通条例发布，绿色出行成主流',
    summary:
      '条例进一步优化公交与地铁接驳，鼓励骑行与步行，推动构建更便捷的绿色出行体系。',
    cover:
      'https://readdy.ai/api/search-image?query=clean%20modern%20city%20bus%20and%20bike%20lane%20with%20autumn%20trees%20along%20the%20road%2C%20editorial%20transportation%20photography%2C%20soft%20daylight&width=1200&height=675&seq=news-03&orientation=landscape',
    category: 'news',
    tags: ['公共交通', '绿色出行', '政策'],
    author: '本刊记者 陈嘉',
    publishedAt: '2026-10-09 11:40',
    views: 8650,
    featured: false,
    content: [
      '新版城市公共交通条例近日公布，围绕线网优化、换乘衔接和适老化服务等方面提出一系列举措。',
      '条例提出，推动公交站点与轨道交通出入口、居住区、商业区一体化设计，缩短换乘距离，让"最后一公里"更加顺畅。',
      '同时，鼓励完善慢行系统，增设自行车停放设施与遮阳避雨设施，为骑行和步行创造更好条件。',
      '有市民表示，绿色出行不仅更环保，成本也更可控，如果换乘足够方便，愿意长期坚持。',
    ],
  },
  {
    id: 'n4',
    title: '多部门联合开展食品安全专项整治行动',
    summary:
      '聚焦校园周边、网络订餐等重点领域，专项行动将排查风险隐患，守护群众"舌尖上的安全"。',
    cover:
      'https://readdy.ai/api/search-image?query=fresh%20vegetables%20and%20fruits%20on%20a%20clean%20market%20stall%20with%20soft%20lighting%2C%20editorial%20food%20safety%20photography&width=1200&height=675&seq=news-04&orientation=landscape',
    category: 'news',
    tags: ['食品安全', '监管', '民生'],
    author: '本刊记者 吴珊',
    publishedAt: '2026-10-08 14:15',
    views: 7320,
    featured: false,
    content: [
      '为进一步加强食品安全监管，多部门近日联合启动专项整治行动，明确重点领域与关键环节的排查任务。',
      '此次行动聚焦校园周边、农贸市场、网络订餐与餐饮集中区，重点检查原料采购、加工操作与环境卫生等情况。',
      '监管部门表示，将坚持"当下改"与"长久立"相结合，对发现的问题依法依规处理，同时推动经营者落实主体责任。',
      '消费者如发现食品安全问题，可通过官方渠道投诉举报，共同参与社会共治。',
    ],
  },
  {
    id: 'n5',
    title: '数字政务加速落地，群众办事实现"一网通办"',
    summary:
      '越来越多事项从"跑多次"变为"跑一次"甚至"零跑动"，数字政务让办事效率不断提升。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20government%20service%20center%20with%20digital%20screens%20and%20bright%20interior%2C%20editorial%20photography%2C%20clean%20minimal%20tone&width=1200&height=675&seq=news-05&orientation=landscape',
    category: 'news',
    tags: ['数字政务', '一网通办', '便民'],
    author: '本刊记者 林清',
    publishedAt: '2026-10-07 10:05',
    views: 9140,
    featured: true,
    content: [
      '只需在手机上点几下，就能完成事项申报、材料上传和进度查询，这样的场景正在越来越多城市成为常态。',
      '各地通过打通部门数据壁垒，推动高频事项"一网通办""跨省通办"，让群众少跑腿、数据多跑路。',
      '在政务服务大厅，自助服务区与帮办代办窗口的设立，帮助不熟悉线上操作的人群也能顺利办事。',
      '相关负责人表示，下一步将持续优化流程，把更多事项纳入线上办理，并加强个人信息保护，让数字化红利惠及更多人。',
    ],
  },
  {
    id: 'n6',
    title: '乡村振兴战略深入推进，特色农业带动农民增收',
    summary:
      '依托本地资源发展特色种植与乡村旅游，乡村产业路子越走越宽，村民收入稳步增长。',
    cover:
      'https://readdy.ai/api/search-image?query=terraced%20farmland%20with%20golden%20autumn%20crops%20and%20distant%20village%2C%20warm%20sunlight%2C%20editorial%20rural%20photography&width=1200&height=675&seq=news-06&orientation=landscape',
    category: 'news',
    tags: ['乡村振兴', '农业', '增收'],
    author: '本刊记者 周衡',
    publishedAt: '2026-10-06 15:30',
    views: 6580,
    featured: false,
    content: [
      '秋收时节，各地乡村一片忙碌。特色种植、农产品加工与乡村旅游的融合，让乡村产业的附加值不断提高。',
      '在一些山区村庄，当地依托气候和土壤优势发展特色水果，通过冷链物流和电商渠道把产品卖到了更远的地方。',
      '与此同时，民宿、采摘和研学等新业态吸引了不少城里人前来体验，村民在家门口就有了新收入。',
      '专家建议，发展乡村产业要因地制宜、突出特色，避免同质化竞争，同时注重生态保护与品牌建设。',
    ],
  },
  {
    id: 'e1',
    title: '秋季档电影市场回暖，多部现实题材影片引热议',
    summary:
      '贴近生活的故事与扎实的表演赢得观众认可，现实题材成为这个秋天电影市场的一大亮点。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20cinema%20hall%20interior%20with%20glowing%20screen%20and%20seats%2C%20editorial%20entertainment%20photography%2C%20cozy%20atmosphere&width=1200&height=675&seq=ent-01&orientation=landscape',
    category: 'entertainment',
    tags: ['电影', '现实题材', '影评'],
    author: '文娱观察 苏晚',
    publishedAt: '2026-10-11 18:45',
    views: 21560,
    featured: true,
    content: [
      '这个秋季档，多部现实题材影片走进影院，把镜头对准普通人的生活，引发了广泛讨论。',
      '有观众表示，影片中没有夸张的情节，却能在细节里看到自己，看完之后久久不能平静。',
      '影评人认为，现实题材作品的走红，说明观众对真诚叙事的渴望，也反映出创作重心正回到内容本身。',
      '业内人士提醒，题材热度之下更要沉下心来打磨剧本，避免跟风扎堆，才能让好作品真正留下来。',
    ],
  },
  {
    id: 'e2',
    title: '音乐节经济持续升温，年轻人为一场演出奔赴一座城',
    summary:
      '音乐节带动交通、住宿与餐饮消费，"跟着演出旅行"成为不少年轻人的假期新选择。',
    cover:
      'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20dusk%20with%20crowd%20and%20colorful%20lights%2C%20editorial%20concert%20photography&width=1200&height=675&seq=ent-02&orientation=landscape',
    category: 'entertainment',
    tags: ['音乐节', '演出经济', '旅行'],
    author: '文娱观察 苏晚',
    publishedAt: '2026-10-10 20:10',
    views: 17320,
    featured: false,
    content: [
      '每到周末，各地音乐节的舞台上灯火通明，台下是挥动着荧光棒的年轻人。',
      '一场演出往往能带动一座城市的短途客流，周边酒店、餐馆和文创市集随之热闹起来。',
      '不少观众表示，去音乐节不只是听歌，更是和志同道合的人一起度过一段难忘时光。',
      '也有乐迷建议，主办方应进一步完善现场秩序、交通接驳和应急保障，让体验更舒适。',
    ],
  },
  {
    id: 'e3',
    title: '综艺市场回归生活质感，慢综艺成新宠',
    summary:
      '告别套路化的竞技和冲突，节奏舒缓、贴近日常的慢综艺获得越来越多观众的偏爱。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20countryside%20cottage%20kitchen%20with%20warm%20lamplight%20and%20cooking%20scene%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=ent-03&orientation=landscape',
    category: 'entertainment',
    tags: ['综艺', '慢综艺', '生活方式'],
    author: '文娱观察 何知',
    publishedAt: '2026-10-09 19:00',
    views: 11240,
    featured: false,
    content: [
      '最近一段时间，几档以日常生活为主题的综艺悄悄走红，没有激烈对抗，却让人看得放松。',
      '节目里，嘉宾一起做饭、聊天、打理小院，平凡的场景被拍得温柔而治愈。',
      '观众说，看这样的节目像是在忙碌生活里偷来的一段安静时光。',
      '制作方表示，慢综艺的关键在于真实，只有尊重生活的节奏，才能真正打动观众。',
    ],
  },
  {
    id: 'e4',
    title: '国风国潮持续走红，传统美学融入现代设计',
    summary:
      '从服饰到家居，从文创到茶饮，越来越多产品把传统元素以年轻化的方式重新表达。',
    cover:
      'https://readdy.ai/api/search-image?query=chinese%20style%20modern%20design%20objects%20with%20silk%20patterns%20and%20porcelain%2C%20editorial%20product%20photography%2C%20warm%20elegant%20tone&width=1200&height=675&seq=ent-04&orientation=landscape',
    category: 'entertainment',
    tags: ['国潮', '传统文化', '设计'],
    author: '文娱观察 何知',
    publishedAt: '2026-10-08 12:20',
    views: 9840,
    featured: false,
    content: [
      '走在街头，带有传统纹样的服饰、融入古典器型的生活用品越来越常见。',
      '设计师们把水墨、刺绣、榫卯等元素进行现代化处理，让传统美学走进日常。',
      '不少年轻人表示，喜欢国潮不仅是因为好看，更是一种文化认同。',
      '业内认为，国潮要走得更远，需要在传承与创新之间找到平衡，避免简单堆砌符号。',
    ],
  },
  {
    id: 'e5',
    title: '短视频创作者转向深度内容，扎实叙事获认可',
    summary:
      '从追求流量到深耕内容，一批创作者用更长的时间和更真的表达，赢得了观众的信任。',
    cover:
      'https://readdy.ai/api/search-image?query=content%20creator%20filming%20with%20camera%20in%20a%20warm%20studio%20setup%2C%20editorial%20media%20photography%2C%20soft%20lighting&width=1200&height=675&seq=ent-05&orientation=landscape',
    category: 'entertainment',
    tags: ['短视频', '内容创作', '创作者'],
    author: '文娱观察 苏晚',
    publishedAt: '2026-10-07 17:35',
    views: 8210,
    featured: false,
    content: [
      '在短视频平台上，一些节奏不快、信息扎实的内容正在收获稳定的关注。',
      '这些创作者愿意花时间做调研、拍素材，把一件事讲清楚，而不是只追求短期的热度。',
      '观众用点赞和收藏给出了回应，评论区里常有人说"看完学到了"。',
      '平台方面也在调整推荐机制，让优质内容获得更公平的展示机会。',
    ],
  },
  {
    id: 'e6',
    title: '剧集市场精品化趋势明显，短剧集受青睐',
    summary:
      '节奏紧凑、叙事完整的短剧集走红，观众用"不拖沓"为好内容投票。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20set%20with%20warm%20lighting%20and%20vintage%20furniture%2C%20editorial%20film%20photography&width=1200&height=675&seq=ent-06&orientation=landscape',
    category: 'entertainment',
    tags: ['剧集', '短剧', '精品化'],
    author: '文娱观察 何知',
    publishedAt: '2026-10-06 21:15',
    views: 7690,
    featured: false,
    content: [
      '近来的剧集市场中，篇幅更短、节奏更快的作品受到不少观众欢迎。',
      '有观众表示，短剧集不注水，每一集都有推进，看得更专注也更过瘾。',
      '创作者认为，压缩篇幅对剧本和表演提出了更高要求，也倒逼行业重视质量。',
      '业内人士分析，精品化是长期趋势，观众最终会为好故事买单。',
    ],
  },
  {
    id: 't1',
    title: '人工智能加速融入日常，智能助手成新工作伙伴',
    summary:
      '从写作整理到日程安排，智能助手正从"新鲜玩意"变为人人可用的实用工具。',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20desk%20with%20laptop%20showing%20ai%20interface%20and%20soft%20blue%20glow%2C%20editorial%20technology%20photography&width=1200&height=675&seq=tech-01&orientation=landscape',
    category: 'tech',
    tags: ['人工智能', '效率工具', '智能助手'],
    author: '科技前线 赵远',
    publishedAt: '2026-10-11 08:30',
    views: 24680,
    featured: true,
    content: [
      '过去一年里，人工智能从实验室走向办公室和家庭，成为许多人习以为常的工具。',
      '在写作、翻译、资料整理和数据分析等场景中，智能助手帮助人们节省了大量重复劳动的时间。',
      '不过，专家也提醒，使用这类工具时要学会辨别信息真伪，重要决策仍需人来把关。',
      '可以预见，会用工具、也更懂判断的人，将在未来的工作中更具优势。',
    ],
  },
  {
    id: 't2',
    title: '折叠屏技术趋于成熟，移动终端形态再进化',
    summary:
      '更轻的铰链、更平整的屏幕与更完善的软件适配，让折叠屏从尝鲜走向日常使用。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20foldable%20smartphone%20on%20a%20minimal%20desk%20with%20soft%20lighting%2C%20editorial%20product%20photography&width=1200&height=675&seq=tech-02&orientation=landscape',
    category: 'tech',
    tags: ['折叠屏', '智能终端', '数码'],
    author: '科技前线 赵远',
    publishedAt: '2026-10-10 13:50',
    views: 15420,
    featured: false,
    content: [
      '折叠屏手机问世数年，随着铰链工艺和屏幕材料的进步，折痕更浅、机身更轻。',
      '与此同时，应用适配不断完善，分屏、悬停等交互方式让大屏的价值真正发挥出来。',
      '有用户表示，展开后像小平板，合起来又能放进兜里，兼顾了便携与效率。',
      '分析师认为，随着成本下降，折叠形态有望在更大范围内普及。',
    ],
  },
  {
    id: 't3',
    title: '新能源汽车渗透率持续攀升，补能网络加速铺开',
    summary:
      '充电桩进小区、进商场、进服务区，补能体验改善让更多人愿意选择新能源汽车。',
    cover:
      'https://readdy.ai/api/search-image?query=electric%20car%20charging%20at%20a%20modern%20station%20with%20clean%20design%2C%20editorial%20automotive%20photography%2C%20soft%20daylight&width=1200&height=675&seq=tech-03&orientation=landscape',
    category: 'tech',
    tags: ['新能源', '汽车', '充电'],
    author: '科技前线 郑岚',
    publishedAt: '2026-10-09 09:10',
    views: 13980,
    featured: false,
    content: [
      '随着车型选择增多和补能条件改善，新能源汽车在越来越多家庭的购车清单中排在前列。',
      '各地加快布局充电设施，小区、商场与高速公路服务区的充电桩数量持续增加。',
      '车主反映，快充技术的进步让长途出行更有底气，排队等待的情况也在减少。',
      '业内人士提醒，选购时要结合自身通勤里程和充电条件，理性看待续航参数。',
    ],
  },
  {
    id: 't4',
    title: '家庭智能设备互联互通，全屋智能走进寻常人家',
    summary:
      '灯光、空调、窗帘与安防设备形成联动，一句指令就能调节整个居家环境。',
    cover:
      'https://readdy.ai/api/search-image?query=smart%20home%20living%20room%20with%20ambient%20lighting%20and%20connected%20devices%2C%20editorial%20interior%20technology%20photography&width=1200&height=675&seq=tech-04&orientation=landscape',
    category: 'tech',
    tags: ['智能家居', '全屋智能', '物联网'],
    author: '科技前线 郑岚',
    publishedAt: '2026-10-08 11:25',
    views: 10650,
    featured: false,
    content: [
      '下班回家，灯光自动亮起、空调调到舒适温度，这样的场景正在更多家庭实现。',
      '随着设备之间的互联互通，用户不必再面对一个个独立的App，统一平台即可管理。',
      '隐私与安全成为关注焦点，厂商开始提供本地化处理和权限管理方案。',
      '专家建议，搭建全屋智能应循序渐进，从高频需求入手，避免为了智能而智能。',
    ],
  },
  {
    id: 't5',
    title: '芯片研发迎来新突破，能效比成为竞争焦点',
    summary:
      '在先进制程之外，架构创新与封装技术同样带来性能提升，能效比受到更多重视。',
    cover:
      'https://readdy.ai/api/search-image?query=macro%20shot%20of%20a%20computer%20chip%20with%20blue%20circuit%20patterns%2C%20editorial%20technology%20photography%2C%20high%20detail&width=1200&height=675&seq=tech-05&orientation=landscape',
    category: 'tech',
    tags: ['芯片', '半导体', '能效'],
    author: '科技前线 赵远',
    publishedAt: '2026-10-07 16:40',
    views: 12470,
    featured: false,
    content: [
      '芯片行业近期动作频频，围绕性能与功耗的平衡，各家给出了不同的技术路线。',
      '除了继续推进制程工艺，架构优化与先进封装也成为提升能效的重要手段。',
      '在移动设备和数据中心等场景，能效比直接影响使用体验与运营成本。',
      '分析认为，未来的竞争将更强调系统级创新，而非单一指标的堆砌。',
    ],
  },
  {
    id: 't6',
    title: '低空经济升温，无人机应用场景不断拓宽',
    summary:
      '从物流配送到农业植保再到应急救援，低空飞行器正创造越来越多的实用价值。',
    cover:
      'https://readdy.ai/api/search-image?query=drone%20flying%20over%20a%20modern%20city%20at%20golden%20hour%20with%20clean%20sky%2C%20editorial%20technology%20photography&width=1200&height=675&seq=tech-06&orientation=landscape',
    category: 'tech',
    tags: ['低空经济', '无人机', '应用'],
    author: '科技前线 郑岚',
    publishedAt: '2026-10-06 10:55',
    views: 8930,
    featured: false,
    content: [
      '随着相关管理规范不断完善，低空经济进入加速发展期，各类飞行器走进更多行业。',
      '在偏远地区，无人机把药品和物资送到交通不便的村落；在农田里，它帮助农户精准作业。',
      '应急救援场景中，无人机可以快速抵达现场传回画面，为决策提供参考。',
      '专家指出，安全与规范是低空经济发展的前提，空域管理和飞行培训需同步跟进。',
    ],
  },
  {
    id: 'l1',
    title: '秋日养生正当时，专家支招科学饮食与作息',
    summary:
      '天气转凉，如何吃得营养、睡得踏实？听听专业人士给出的实用建议。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20autumn%20healthy%20meal%20with%20porridge%20fruits%20and%20tea%20on%20wooden%20table%2C%20editorial%20food%20photography&width=1200&height=675&seq=life-01&orientation=landscape',
    category: 'life',
    tags: ['养生', '健康', '饮食'],
    author: '生活指南 顾棠',
    publishedAt: '2026-10-11 07:15',
    views: 16430,
    featured: true,
    content: [
      '进入秋季，昼夜温差加大，人体容易出现干燥、乏力等不适，饮食和作息都需要相应调整。',
      '饮食上可适当增加润燥的食材，如银耳、梨、百合等，同时保证优质蛋白和蔬菜的摄入。',
      '作息方面建议早睡早起，避免熬夜，并保持适度运动，让身体慢慢适应季节变化。',
      '专家提醒，养生要因人而异，慢性病人群应遵医嘱，不盲目跟风进补。',
    ],
  },
  {
    id: 'l2',
    title: '城市近郊露营热度不减，轻户外成周末新选择',
    summary:
      '不必远行，一片草地、一顶帐篷就能放松身心，轻量化露营受到家庭和上班族欢迎。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20camping%20tent%20on%20a%20grassy%20hillside%20at%20sunset%20with%20warm%20light%2C%20editorial%20outdoor%20lifestyle%20photography&width=1200&height=675&seq=life-02&orientation=landscape',
    category: 'life',
    tags: ['露营', '户外', '周末'],
    author: '生活指南 顾棠',
    publishedAt: '2026-10-10 09:40',
    views: 12110,
    featured: false,
    content: [
      '越来越多的人把周末交给近郊的草地和山野，用一场轻露营来给自己充电。',
      '相比长途跋涉，近郊露营门槛更低，一个下午就能完成从出发到返程的完整放松。',
      '参与者分享，带上折叠椅、便携炉和一点食物，简单布置就很惬意。',
      '也要提醒大家，离开时带走垃圾、减少明火，把自然的美好留给下一位来客。',
    ],
  },
  {
    id: 'l3',
    title: '家电以旧换新政策落地，换新流程更便捷',
    summary:
      '旧家电上门回收、新家电补贴直减，换新更省心，也让更多节能产品走进家庭。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20kitchen%20appliances%20arranged%20neatly%20with%20soft%20daylight%2C%20editorial%20home%20appliance%20photography&width=1200&height=675&seq=life-03&orientation=landscape',
    category: 'life',
    tags: ['家电', '以旧换新', '消费'],
    author: '生活指南 白榆',
    publishedAt: '2026-10-09 14:05',
    views: 8760,
    featured: false,
    content: [
      '家电以旧换新政策近期进一步扩围，覆盖品类增加，办理流程也更加简便。',
      '不少平台提供上门回收服务，旧机估价后即可抵扣新机款项，省去了搬运的麻烦。',
      '消费者在换购时，可以优先考虑能效等级更高的产品，长期使用更省电。',
      '提醒大家保留好购买凭证，仔细阅读补贴规则，避免影响后续办理。',
    ],
  },
  {
    id: 'l4',
    title: '秋冬流感高发季，这份家庭防护指南请收好',
    summary:
      '勤通风、戴口罩、及时接种疫苗，几个小习惯就能为家人筑起一道健康屏障。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20home%20interior%20with%20medicine%20box%20and%20hygiene%20items%20on%20table%2C%20editorial%20health%20photography%2C%20soft%20light&width=1200&height=675&seq=life-04&orientation=landscape',
    category: 'life',
    tags: ['健康', '防护', '流感'],
    author: '生活指南 白榆',
    publishedAt: '2026-10-08 08:20',
    views: 10420,
    featured: false,
    content: [
      '每到秋冬，流感进入高发期，老人和孩子尤其需要重点防护。',
      '日常应保持室内通风，勤洗手，在人群密集场所佩戴好口罩。',
      '接种疫苗是有效的预防手段，建议在流行季来临前咨询医生完成接种。',
      '如果出现持续发热等症状，应及时就医，不要自行随意用药。',
    ],
  },
  {
    id: 'l5',
    title: '通勤族时间管理指南：把碎片时间用起来',
    summary:
      '通勤路上的一小时，既能学点新东西，也能好好休息，关键是找到适合自己的方式。',
    cover:
      'https://readdy.ai/api/search-image?query=person%20reading%20on%20a%20subway%20commute%20with%20warm%20interior%20light%2C%20editorial%20lifestyle%20photography&width=1200&height=675&seq=life-05&orientation=landscape',
    category: 'life',
    tags: ['时间管理', '通勤', '效率'],
    author: '生活指南 顾棠',
    publishedAt: '2026-10-07 07:50',
    views: 9340,
    featured: false,
    content: [
      '对于通勤族来说，每天往返路上的时间加在一起并不少，合理利用能减轻不少焦虑。',
      '可以利用这段相对固定的时间听音频、列清单或做当天的简单规划。',
      '如果太累，闭目养神也是一种高效选择，休息好才更有精力应对工作。',
      '关键是不要一味要求自己"必须学到什么"，找到舒服的节奏才能长久坚持。',
    ],
  },
  {
    id: 'l6',
    title: '社区便民服务升级，一刻钟生活圈加速成型',
    summary:
      '下楼就能买菜、理发、寄快递，家门口的服务越来越齐全，生活半径越来越便利。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20neighborhood%20street%20with%20small%20shops%20and%20green%20trees%2C%20warm%20daylight%2C%20editorial%20community%20photography&width=1200&height=675&seq=life-06&orientation=landscape',
    category: 'life',
    tags: ['社区服务', '生活圈', '便民'],
    author: '生活指南 白榆',
    publishedAt: '2026-10-06 13:30',
    views: 7120,
    featured: false,
    content: [
      '如今，越来越多社区把便民服务嵌入居民的日常动线，力求在步行一刻钟内满足基本需求。',
      '生鲜店、维修点、快递驿站和社区食堂的增设，让居民的琐事不用跑远就能解决。',
      '一些社区还引入预约式服务，老人可以在家门口享受到上门照料。',
      '相关负责人表示，生活圈建设会持续听取居民意见，让服务更贴合真实需求。',
    ],
  },
];